export default "__VITE_ASSET__a357182e__"